import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/borrowing-spare-part-claims', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const updateRef = (id, data) => {
  return httpClient
    .put(`/api/v1/borrowing-spare-part-claims/${id}/references`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { 
    get, 
    updateRef
}
